import memoizeOne from 'memoize-one';
import { connect } from 'react-redux';
import { selectChangedItemsStatus, State as GroupProductState } from '~/GroupProduct';
import { ChangedItemStatus } from '~/GroupProduct/reducer';
import SaveActivityIndicator, { Status, Statuses } from '~/UI/SaveActivityIndicator/SaveActivityIndicator';

const selectStatus = memoizeOne((groupId: string, state: GroupProductState): Status | null => {
	const changedItemsStatus = selectChangedItemsStatus(state, groupId);
	if (!changedItemsStatus) {
		return null;
	}

	const statuses = Object.keys(changedItemsStatus).reduce((result: { [key in ChangedItemStatus]: boolean }, key) => {
		result[changedItemsStatus[key]] = true;
		return result;
	}, {} as { [key in ChangedItemStatus]: boolean });

	if (statuses.changed || statuses.updating) {
		return Statuses.saving;
	}
	if (statuses.failed) {
		return Statuses.failed;
	}
	if (statuses.saved) {
		return Statuses.saved;
	}
	return null;
});

function mapStateToProps(
	{ groupProduct }: { groupProduct: GroupProductState },
	{ groupId }: { groupId: string; hideAfterMilliseconds: number }
): { status: Status | null } {
	return {
		status: selectStatus(groupId, groupProduct),
	};
}

export default connect(mapStateToProps, null)(SaveActivityIndicator);
